import { format, parseISO, isValid } from 'date-fns';

/**
 * Convert an ISO timestamp into the value expected by an
 * `<input type="datetime-local">`, expressed in the browser's local time.
 * Returns an empty string for missing/invalid input.
 */
export function isoToDatetimeLocal(iso?: string | null): string {
  if (!iso) return '';
  const date = parseISO(iso);
  if (!isValid(date)) return '';
  return format(date, "yyyy-MM-dd'T'HH:mm");
}

/**
 * Convert a `datetime-local` input value (local time, no timezone) into an ISO
 * timestamp for the API. Returns null for an empty value so callers can clear
 * the field, or when the value cannot be parsed.
 */
export function datetimeLocalToIso(value: string): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (!isValid(date)) return null;
  return date.toISOString();
}
